module.exports = __webpack_public_path__ + "static/img/14.6442f7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/14.png
// module id = 1ws8
// module chunks = 0